import { mapToBillingAddress, mapToShippingAddress } from "@common/lib/address";
import { type Checkout } from "../../types";

export const getMapOutput =
  (addressType: "billing" | "shipping") =>
  ({
    isSameAsShipping,
    ...address
  }: Checkout.View.Address): Partial<Checkout.Api.BillingInformation> | Partial<Checkout.Api.ShippingInformation> => {
    if (isSameAsShipping)
      return {
        isSameAsShipping: true
      };

    return addressType === "billing" ? mapToBillingAddress(address) : mapToShippingAddress(address);
  };
